var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('myCinemaList',{attrs:{"isActive":_vm.isActive,"goodsInfo":_vm.goodsInfo,"customerCinema":_vm.customerCinema,"cinemaInfo":_vm.cinemaInfo},on:{"getCinemas":_vm.onLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }